export default "__VITE_ASSET__BOYJfD52__"